<script>
  import Bleed from "./Bleed.svelte";
  import { getContext, setContext } from "svelte";
  import Heading from "./Heading.svelte";

  export let numberOfColumns;

  //Unsupported right now in content type, but leaving in for use in social media feed when ready
  export let masonry = false;
  export let header;

  export let items;
  export let contentType; //Use this when layout is used internally, for a social media feed or IPL for example
  export let componentMap;

  function getComponent(typename) {
    let component = componentMap[typename];
    if (!component) {
      // eslint-disable-next-line no-console
      console.warn(`Component missing: ${typename}`);
    }
    return component;
  }

  /** @type {"Round Robin" | "Body Copy Wrap" | "Last Entries First"} */
  export let fillStrategy = "Round Robin";

  //Tailwind is not a fan of the dynamic sizing on these, so pre-loading values:
  // md:grid-cols-1 lg:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 lg:grid-cols-3 lg:grid-cols-4
  // columns-1 lg:columns-1 md:columns-2 lg:columns-2 lg:columns-3 lg:columns-4 space-y-32 lg:space-y-72

  let tabletColumns = numberOfColumns > 1 ? 2 : 1;
  $: layoutClasses = masonry
    ? `columns-1 md:columns-${tabletColumns} lg:columns-${numberOfColumns} w-full gap-48 md:gap-72 space-y-32 lg:space-y-72`
    : fillStrategy == "Body Copy Wrap"
      ? `columns-1 lg:columns-${numberOfColumns} w-full gap-93`
      : `grid grid-flow-row grid-cols-1 md:grid-cols-${tabletColumns} lg:grid-cols-${numberOfColumns} auto-cols-auto gap-48 md:gap-72`;

  $: widthClass =
    numberOfColumns == 2
      ? "lg:max-w-lg-container"
      : numberOfColumns == 3
        ? "lg:max-w-md-container"
        : numberOfColumns == 4
          ? "lg:max-w-sm-container"
          : "";

  $: items = fillStrategy === "Last Entries First" ? [...items].reverse() : items;

  //This "sectionContent" context is set via the "SectionComponent" type.
  let sectionDescendant = getContext("sectionDescendant");

  //Regardless, everything should be containerized from here down.
  setContext("containerized", true);

  let sectionDescendantStyle = sectionDescendant ? "lg:px-0" : "";
  let layoutMargin = sectionDescendant ? "" : " px-0 md:px-24 lg:px-72";

  let sectionDescendantEmbed = sectionDescendant ? "-mx-48" : "-mx-24";

  const paddingStyle = `px-24 md:px-0 `;
</script>

<Bleed fullWidth={!sectionDescendant} class={sectionDescendantStyle}>
  <div class={`max-w-max ${layoutMargin} mx-auto`}>
    {#if header}
      <div class="{paddingStyle} lg:max-w-lg-container">
        <Heading text={header} class={"heading heading-3 pb-48 lg:pb-72"} />
      </div>
    {/if}

    <div class={`layout-items-container ${layoutClasses}`}>
      {#each items as item}
        {@const typename = contentType || getComponent(item.sys.contentType.sys.id)}
        <div class="layout-item {paddingStyle} ${widthClass} w-full mx-auto">
          <svelte:component
            this={typename}
            data={item}
            {...item}
            class={item.sys?.contentType.sys.id === "embed"
              ? `${sectionDescendantEmbed} md:mx-0`
              : ""}
          >
            <slot />
          </svelte:component>
        </div>
      {/each}
    </div>
  </div>
</Bleed>
